/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_Field_Pattern_NameInputs */



/**
* | output |
* | --- |
* | "Pattern Name" |
*
* @param {Audit_Export_Field_Pattern_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_field_pattern_name = /** @type {((inputs?: Audit_Export_Field_Pattern_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_Field_Pattern_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mustername")
	return /** @type {LocalizedString} */ ("Pattern Name")
});